var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApprove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83301 0.828125C3.35449 0.828125 0.536133 3.67188 0.536133 7.125C0.536133 10.6035 3.35449 13.4219 6.83301 13.4219C10.2861 13.4219 13.1299 10.6035 13.1299 7.125C13.1299 3.67188 10.2861 0.828125 6.83301 0.828125ZM6.83301 12.6094C3.81152 12.6094 1.34863 10.1719 1.34863 7.125C1.34863 4.12891 3.78613 1.64062 6.83301 1.64062C9.8291 1.64062 12.3174 4.10352 12.3174 7.125C12.3174 10.1465 9.85449 12.6094 6.83301 12.6094ZM10.4131 5.65234C10.54 5.52539 10.54 5.32227 10.4131 5.2207L10.21 4.99219C10.083 4.86523 9.87988 4.86523 9.77832 4.99219L5.61426 9.10547L3.8623 7.35352C3.76074 7.22656 3.55762 7.22656 3.43066 7.35352L3.22754 7.55664C3.10059 7.68359 3.10059 7.86133 3.22754 7.98828L5.41113 10.1973C5.5127 10.2988 5.71582 10.2988 5.84277 10.1973L10.4131 5.65234Z",
    fill: "#383838"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.c2665a5b.svg";
export { ForwardRef as ReactComponent };